import { render, staticRenderFns } from "./NeedElites.vue?vue&type=template&id=b05258be&scoped=true&"
import script from "./NeedElites.vue?vue&type=script&lang=js&"
export * from "./NeedElites.vue?vue&type=script&lang=js&"
import style0 from "./NeedElites.vue?vue&type=style&index=0&id=b05258be&prod&lang=css&"
import style1 from "./NeedElites.vue?vue&type=style&index=1&id=b05258be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05258be",
  null
  
)

export default component.exports